import { IntegerProblem } from '@/core/cuts'

// Centralizes default problem construction and future variations
export const ProblemManager = {
  createDefault3DProblem(): IntegerProblem {
    return {
      A: [
        [3, 1, 1],
        [1, 3, 1],
        [1, 1, 3],
        [-1, 0, 0],
        [0, -1, 0],
        [0, 0, -1],
      ],
      b: [7, 7, 7, 0, 0, 0],
      c: [1, 1, 1],
      inequalities: [
        { alpha: [3, 1, 1], beta: 7 },
        { alpha: [1, 3, 1], beta: 7 },
        { alpha: [1, 1, 3], beta: 7 },
        { alpha: [-1, 0, 0], beta: 0 },
        { alpha: [0, -1, 0], beta: 0 },
        { alpha: [0, 0, -1], beta: 0 },
      ],
    }
  },
}
